import { render, staticRenderFns } from "./intDetail.vue?vue&type=template&id=1401bd8f&scoped=true&"
import script from "./intDetail.vue?vue&type=script&lang=js&"
export * from "./intDetail.vue?vue&type=script&lang=js&"
import style0 from "./intDetail.vue?vue&type=style&index=0&id=1401bd8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401bd8f",
  null
  
)

export default component.exports